import { GET_ACCESS_USERS } from "./types";

const AccessUsersReducer = (state, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_ACCESS_USERS:
            return {
                ...state,
                accessUsers: payload,
                isFetching: false,
                wasFetched: true,
                error: false,
                message: ''
            }

        default:
            return state;
    }
}

export default AccessUsersReducer